import gql from 'graphql-tag';

import { Guest } from 'types/guest.types';
import { QuestionResponse } from 'types/question-response.types';
import { WaitlistAdjustmentOption } from 'types/rsvp_control.types';

export interface UpdateQuestionnaireResponsesMutationVariables {
  input: {
    gid: string;
    eventId: number;
    responses: QuestionResponse[];
  };
}

export interface UpdateQuestionnaireResponsesMutationResponse {
  updateQuestionnaireResponses: {
    ok: boolean;
    responses: { questionId: number; response: string[] | string }[];
  };
}

export const UPDATE_QUESTIONNAIRE_RESPONSES_MUTATION = gql`
  mutation UpdateQuestionnaireResponses($input: UpdateGuestQuestionnaireResponseInput!) {
    updateQuestionnaireResponses(input: $input) {
      ok
    }
  }
`;

export interface UpdateRSVPForGuestMutationVariables {
  gid: string;
  eventId: number;
  status: string;
  sendNotifications: boolean;
  waitlistAdjustmentOption?: WaitlistAdjustmentOption;
  swapGuest?: { gid: string; status: string };
  questionnaireResponses?: QuestionResponse[];
}

export enum UpdateRSVPForGuestError {
  INVALID_STATUS_CHANGE = 'INVALID_STATUS_CHANGE',
  WAITLIST_ADJUSTMENT_OPTION_NOT_PROVIDED = 'WAITLIST_ADJUSTMENT_OPTION_NOT_PROVIDED',
  SWAP_GUEST_NOT_PROVIDED = 'SWAP_GUEST_NOT_PROVIDED',
  SWAP_GUEST_DOES_NOT_EXIST = 'SWAP_GUEST_DOES_NOT_EXIST',
  SWAP_GUEST_WILL_NOT_FREE_SPOT = 'SWAP_GUEST_WILL_NOT_FREE_SPOT',
  INVALID_SWAP_GUEST_STATUS_CHANGE = 'INVALID_SWAP_GUEST_STATUS_CHANGE',
  EVENT_IS_OVER = 'EVENT_IS_OVER',
  LIMITED_REGISTRATION_ALREADY_ATTENDED = 'LIMITED_REGISTRATION_ALREADY_ATTENDED',
  FAILED_TO_SWAP_GUEST = 'FAILED_TO_SWAP_GUEST',
  FAILED_TO_UPDATE_QUESTIONNAIRE = 'FAILED_TO_UPDATE_QUESTIONNAIRE',
  FAILED_TO_UPDATE_SESSION_EVENT_STATUS = 'FAILED_TO_UPDATE_SESSION_EVENT_STATUS',
  FAILED_TO_UPDATE_PARENT_EVENT_STATUS = 'FAILED_TO_UPDATE_PARENT_EVENT_STATUS',
  FAILED_TO_UPDATE_SINGLE_EVENT_STATUS = 'FAILED_TO_UPDATE_SINGLE_EVENT_STATUS'
}

export interface UpdateRSVPForGuestMutationResponse {
  updateRsvpForGuest: {
    ok: boolean;
    guest: Guest;
    swapGuest?: Guest;
  };
}
export const UPDATE_RSVP_FOR_GUEST = gql`
  mutation UpdateRSVPForGuest(
    $gid: String!
    $eventId: Int!
    $status: GuestStatus!
    $sendNotifications: Boolean!
    $waitlistAdjustmentOption: WaitlistAdjustmentOption
    $swapGuest: SwapGuestInput
    $questionnaireResponses: [QuestionResponseInput]
  ) {
    updateRsvpForGuest(
      input: {
        gid: $gid
        eventId: $eventId
        status: $status
        waitlistAdjustmentOption: $waitlistAdjustmentOption
        swapGuest: $swapGuest
        questionnaireResponses: $questionnaireResponses
        sendNotifications: $sendNotifications
      }
    ) {
      ok
      guest {
        gid
        email
        eventId
        status
      }
      swapGuest {
        gid
        email
        eventId
        status
      }
    }
  }
`;
